var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickOnlineLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1504.15 336.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1{fill:#5b6871;}.cls-2{fill:#ea002a;}\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M929.29,171.53c-9.78,55.43-52.62,86.65-100.8,86.65-51.13,0-79.71-31.68-69.93-87.1,9-51.13,49.5-84.39,100.17-84.39C916.88,86.69,936.87,128.54,929.29,171.53Zm-117.42,0c-3.67,20.81-1.93,46.83,23.64,46.83,23.08,0,35.64-19.91,40.38-46.83,3.92-22.17-1-45.7-24.63-45C827.05,126.51,815.5,150.94,811.87,171.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M950.38,135.33h43l-3.27,18.55c13.15-14.25,26-21.94,43.91-21.94,31.22,0,42.7,18.32,37,50.9l-12.53,71h-47.06l11.06-62.67c2.07-11.76.74-22.17-12.61-22.17-14.48,0-20,9.28-22.63,24.43l-10.66,60.41h-47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1077,253.88,1105.7,91h47.06L1124,253.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1146.88,253.88l20.91-118.55h47l-20.9,118.55Zm29.49-167.19h47.06l-5.91,33.48h-47.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1235.54,135.33h43l-3.27,18.55c13.14-14.25,26-21.94,43.91-21.94,31.22,0,42.69,18.32,36.95,50.9l-12.53,71h-47.06l11-62.67c2.08-11.76.75-22.17-12.6-22.17-14.48,0-20,9.28-22.63,24.43l-10.66,60.41h-47.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1412.57,205.24c-2.47,14,6.75,23.3,19.19,23.3a23,23,0,0,0,19.49-10.41h45c-13.34,29.41-44.91,39.14-72.51,39.14-38,0-63.59-21.72-56.57-61.53,6.87-38.92,40.44-63.8,78.45-63.8,43.89,0,65,30.31,56.75,73.3Zm47-24a17.33,17.33,0,0,0-17.18-20.59c-14,0-23.34,7.92-25.58,20.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "722.9 158.43 737.14 70.35 678.34 70.35 653.69 225.17 722.9 158.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "765.78 197.27 763.87 193.89 779.02 176.7 815.28 135.5 771.36 135.5 649.26 252.31 649.05 253.43 707.87 253.43 714.92 209.88 716.26 209.88 732.92 253.43 760.22 253.43 797.69 253.43 765.78 197.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "551.35 164.29 556.36 132.56 497.56 132.56 481.96 231.03 551.35 164.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M611.54,130,483.16,253.54h54l6.55-41.19c2.86,28.55,25.33,43.94,58,43.94,10.26,0,20.93-2.75,30.52-5.71l10.38-49.69c-7.6,4.79-15.15,9.35-24.28,9.35-9.57,0-16.1-7.74-14.57-17.29,1.73-11,10.6-18,21.32-18,8.41,0,14.74,4.78,20.07,10l7.73-49a111.29,111.29,0,0,0-35.95-6.17C615.13,129.81,613.32,129.88,611.54,130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M549.07,66.16a39.37,39.37,0,0,0-11.73-1.67c-18.45,0-34,10.69-36.81,28.23-1.15,7.29,0,13,2.82,17.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M517.82,119.92a41.94,41.94,0,0,0,10.55,1.3c16.88,0,33.75-8.67,36.87-28.5,1-6.32,0-11.71-2.44-16.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M480.08,132.56H424.25L414.34,195c0,.34-.09.67-.16,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335,200.89c-3.81,24.09,6.85,39.81,24,48.1l41.1-39.54c-7.61-1-6.89-7.91-5.85-14.48l9.87-62.41H349.58v-.35a118.58,118.58,0,0,0-19.33-64.55L272.79,123a62.44,62.44,0,0,1,.82,10.12c0,38-33.82,68.77-75.56,68.77-2.35,0-4.68-.11-7-.29l-53.94,51.87a170.79,170.79,0,0,0,60.63,11c63,0,117-33.43,140-81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377.58,254.82a96.86,96.86,0,0,0,17,1.47c35.09,0,71.08-17.11,77.13-55.4l6.87-43.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M197.77,0C113.92,0,46,59.19,46,132.21c0,31.84,12.91,61,34.41,83.8L33.1,261.55l13.82,5.08L23.55,293l15.77,4.43L0,337.3,101,293l-15.46-5.5L124,261.55l-15.76-4L213.62,157.26H141.35l-9.4,9.06a63.69,63.69,0,0,1-9.45-33.24c0-38,33.82-68.81,75.55-68.81,30.67,0,57.09,16.68,68.92,40.59l53-51C292.36,21.19,247.9,0,197.77,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickOnlineLogo);
export default __webpack_public_path__ + "static/media/quick-online-logo.2f6bd455ff343adb39e4251dbb83bed3.svg";
export { ForwardRef as ReactComponent };